export function mapDateToSchoolyear(date: Date) {
    if (date.getMonth() < 8) {
      return date.getFullYear() - 1;
    } else {
      return date.getFullYear();
    }
}